<template>
    <div class="xcard">
        <v-btn small class="ma-0" @click="$router.back()" color="info" rounded outlined> <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras </v-btn>
        <h3 class="text-primary text-center mt-0 pt-0 mb-2">
            Reponsables de cobranzas asignados al programa
        </h3>
        <p class="text-center mb-0">
            <b> {{ prog.nombre_compuesto }} </b>
        </p>
        <p class="text-center mt-0">ID - {{ prog.id }}</p>
        <hr />

        <v-tooltip bottom v-if="$store.state.CARGO.id==14 || $store.state.CARGO.id==1">
            <template v-slot:activator="{ on, attrs }">
                <button v-bind="attrs" v-on="on" @click="asignarcobradorprog()" v-show="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 14 || $store.state.CARGO.id == 15 || $store.state.CARGO.id == 25 || $store.state.CARGO.id == 19" class="btn btn-sm btn-default">
                    <v-icon small class="mx-1" color="primary">mdi-account-cash</v-icon>
                    Asignar Responsable de cobranzas
                </button>
            </template>
            <span> Asignar Responsable de cobranza. </span>
        </v-tooltip>

        <div class="mt-4"><AProgramacobrador ref="programacobradortabla" v-on:dataloaded="dataloaded" /></div>

        <p class="text-center text-danger">
            <b>{{ msg }}</b>
        </p>

        <div class="text-center">
            <div style="display: inline-block;" v-show="loading" class="loader"></div>
        </div>

        <div> <notifications group="authx" position="bottom right" /> </div>
        <div><AsignarCobradorProg ref="asignarcobradorprog" v-on:onnew="listarsignaciones"/></div>
    </div>
</template>

<script>
import AProgramacobrador from "@/components/AProgramacobrador.vue";
import AsignarCobradorProg from "@/components/AAsignarCobradorProg.vue";

export default {
    data() {
        return {
            loading: false,
            prog: {},
            msg: "",
        };
    },
    watch: {},
    components: { AProgramacobrador, AsignarCobradorProg },
    methods: {
        resetasignaciones() {
            this.$refs.programacobradortabla.resetasignaciones();
        },
        listarsignaciones() {
            this.loading = true;
            this.$refs.programacobradortabla.obtenerasignaciones(null,null,this.prog);
        },
        dataloaded() {
            this.loading = false;
        },
        asignarcobradorprog() {
            this.$refs.asignarcobradorprog.open(this.prog);
        },
    },
    mounted() {
        window.console.log("HOLA MUNDO::::", this.$route.params.prog);
        this.prog = this.$route.params.prog;
        this.listarsignaciones();
    },
};
</script>
